import { foundationDataGridStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { defaultRapidLabelColor } from '../_common';
export const zeroDataGridStyles = (context, defintion) => css `
  ${foundationDataGridStyles(context, defintion)}
  ::slotted(.sticky-header),
  ::slotted(.header) {
    border-bottom-color: var(--neutral-color);

    --neutral-foreground-rest: ${defaultRapidLabelColor};
  }

  ::slotted([role='row']) {
    background-color: #1f2126;
  }
`;
